// Table
import Table from '../ui/table/Table'

// Mantine
import { Anchor, RingProgress } from '@mantine/core'

// Custom UI components
import Badge from '@/components/ui/Badge'

// Dayjs
import dayjs from 'dayjs'

// Classnames
import classNames from 'classnames'

// Production order statuses
import statuses from '@/lib/productionOrderStatuses'

export default function ProductionOrderTable() {
    // Cells
    const IdCell = (item) => {
        const quantityCompletedPercentage =
            (item.quantity_completed / item.quantity) * 100

        const quantityInControlPercentage =
            (item.quantity_in_control / item.quantity) * 100

        const status = statuses(item)

        const titleClasses = classNames('font-medium', {
            'line-through text-gray-400': item.status === 'cancelled',
        })

        return (
            <div className="table-cell p-4 align-middle">
                <div className="flex items-center gap-4">
                    <RingProgress
                        size={48}
                        thickness={10}
                        roundCaps
                        sections={[
                            ...(quantityCompletedPercentage > 0
                                ? [{ value: quantityCompletedPercentage, color: 'green' }]
                                : []),
                            ...(quantityInControlPercentage > 0
                                ? [{ value: quantityInControlPercentage, color: 'orange' }]
                                : []),
                        ]}
                    />

                    <div className="flex-1 min-w-0">
                        <div className={titleClasses}>
                            <Anchor
                                href={`/assembly/${item.id}`}
                            >
                                A{item.id} - {item.component.name} ({item.quantity})
                            </Anchor>
                        </div>

                        <div className="text-sm text-gray-400">
                            Du {dayjs(item.starting_at).format('D MMM YYYY')} au{' '}
                            {dayjs(item.ending_at).format('D MMM YYYY')}
                            {item.references?.length > 0 && (
                                <> · {Array.isArray(item.references) ? item.references.join(', ') : item.references}</>
                            )}
                        </div>

                        {item.quantity_in_control > 0 && (
                            <span className="text-sm text-orange-500">
                                {item.quantity_in_control} en contrôle
                            </span>
                        )}
                    </div>

                    <div className="flex flex-col items-end gap-2 shrink-0">
                        <span className="text-sm text-gray-400">
                            {item.location.name}
                        </span>

                        <Badge color={status.badgeColor} size="sm">
                            {status.label}
                        </Badge>
                    </div>
                </div>
            </div>
        )
    }

    // Columns
    const availableColumns = [
        {
            name: 'Assemblage',
            key: 'starting_at',
            sortable: true,
            display: 'mandatory',
            component: IdCell,
        },
    ]

    // Filters
    const statusOptions = [
        { value: 'scheduled', label: 'Programmé' },
        { value: 'open', label: 'En cours' },
        { value: 'closed', label: 'Terminé' },
        { value: 'cancelled', label: 'Annulé' },
    ]

    const availableFilters = [
        {
            name: 'Statut',
            key: 'status',
            type: 'multiselect',
            options: statusOptions,
        },
    ]

    return (
        <Table
            availableColumns={availableColumns}
            availableFilters={availableFilters}
            engineApiEndpoint="/production-orders"
            defaultSortColumn="starting_at"
            defaultSortDirection="asc"
            linkItemUrl="/assembly"
            linkItemId="id"
            searchable={true}
            withLocationAll={true}
            withLocation={true}
            onlyProductComponentsLocations={true}
        />
    )
}
